import {IExtensionPoints, IPlugin, IPluginConfig} from "@athena-portal/core";
import {HelloPage} from "../pages/HelloPage";
import {FalconPropositionEngineImpl, IFalconPropositionEngine, Types} from "@ferry/journey-services";
import {RetrievalDetailsPage} from "../pages/quote/RetrievalDetailsPage";
import {RenewalQuotePage} from "../pages/RenewalQuotePage";
import {RetrieveQuotePage} from "../pages/quote/RetrieveQuotePage";
import {RetrieveQuoteAndProceedPage} from "../pages/quote/RetrieveQuoteAndProceedPage";
import {QuoteLimit} from "../pages/quote/QuoteCloneLimitPage";
import {EventWarningPage} from "../pages/EventWarningPage";
import {LoginPage} from "../pages/LoginPage";
import {RegisterPage} from "../pages/RegisterPage";
import {ComplaintsPage} from "../pages/ComplaintsPage";

const plugin: IPlugin<IPluginConfig> = {
    getName(): string {
        return "customerPortal";
    },

    register(extensions: IExtensionPoints, configuration: IPluginConfig): void {
        // Routes
        extensions.routes.add({
            path: "/",
            component: HelloPage,
        });

        extensions.routes.add({
            path: "/retrieveQuote",
            component: RetrievalDetailsPage,
        });

        extensions.routes.add({
            path: "/renewalQuote",
            component: RenewalQuotePage,
        });

        extensions.routes.add({
            path: "/retrieveQuote/products/:product/process/:process/interaction/:interactionId/language/:languageCode/email/:email/dob/:dateOfBirth",
            component: RetrieveQuotePage,
        });

        extensions.routes.add({
            path: "/retrieveQuote/:token",
            component: RetrieveQuoteAndProceedPage,
        });

        extensions.routes.add({
            path: "/quoteLimit",
            component: QuoteLimit,
        });

        extensions.routes.add({
            path: "/eventWarningPage",
            component: EventWarningPage,
        });

        extensions.routes.add({
            path: "/login",
            component: LoginPage,
        });

        extensions.routes.add({
            path: "/register",
            component: RegisterPage,
        });

        extensions.routes.add({
            path: "/complaints",
            component: ComplaintsPage,
        });

        // Services
        extensions.services.bind<IFalconPropositionEngine>(Types.FalconPropositionEngine).to(FalconPropositionEngineImpl);
    }
};

export default plugin;
